import { render, staticRenderFns } from "./JobProfileForm.vue?vue&type=template&id=68679004&"
import script from "./JobProfileForm.vue?vue&type=script&lang=js&"
export * from "./JobProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports